import { cities, hero } from '../../../config/appData';
import './Hero.css';
import weddingBg from '../../../assets/home.avif';
import { useSearchParams, useNavigate, useLocation } from 'react-router-dom';
import { useAppDispatch } from '../../../Utility';
import { onsaveSelectedCity } from '../../../Store/Slices/utilitySlice';
import {
  buildHomeCityPath,
  getListingCityFromPathname,
} from '../../../utils/listingPaths';

function Hero() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const urlCity =
    getListingCityFromPathname(location.pathname) ||
    searchParams.get('city') ||
    '';

  const displayCity = urlCity;

  const handleCityChange = (e) => {
    const city = e.target.value;
    if (city && city !== hero.citySelectPlaceholder) {
      navigate(buildHomeCityPath(city));
      dispatch(onsaveSelectedCity({ selectedCity: city }));
    } else {
      navigate('/', { replace: true });
      dispatch(onsaveSelectedCity({ selectedCity: '' }));
    }
  };

  return (
    <section className="hero">
      <div className="hero-background">
        <img 
          src={weddingBg}
          alt="Wedding background"
          className="hero-background-image"
          loading="eager"
          decoding="sync"
        />
        <div className="hero-overlay"></div>
      </div>
      <div className="hero-content">
    
        <h2 className="hero-title">
          {hero.title.map((line, index) => (
            <span key={index} className="title-line">{line}</span>
          ))}
        </h2>
        <p className="hero-subtitle">
          {hero.subtitle}
        </p>
        <div className="hero-cta">
          <div className="select-wrapper">
            <svg className="select-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
              <circle cx="12" cy="10" r="3"></circle>
            </svg>
            <select 
              className="hero-city-select"
              value={displayCity}
              onChange={handleCityChange}
            >
              <option value="">{hero.citySelectPlaceholder}</option>
              {cities.map((city, index) => (
                <option key={index} value={city}>
                  {city}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="hero-taglines">
          {hero.taglines.map((line, index) => (
            <span key={index} className="hero-tagline-pill">
              {line}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Hero;
